import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative z-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg mt-4 lg:mt-10 uppercase text-gray-500" }, "Wiebe Ranzijn", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserNameSvg = _resolveComponent("UserNameSvg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UserNameSvg, { class: "w-48 lg:w-auto" }),
    _hoisted_2
  ]))
}